import React from 'react';

const About = () => {
  return (
    <div className="min-h-screen py-24 md:py-32 px-6 md:px-12">
      <div className="container mx-auto max-w-4xl">
        <h1 className="font-heading text-4xl md:text-5xl font-normal tracking-tight text-charcoal mb-16 text-center">
          Oor die Boek
        </h1>

        <div className="space-y-12 font-body text-lg leading-loose text-charcoal">
          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              Die Voortrekker Monument se Donker Geheim
            </h2>
            <p className="mb-4">
              <em>Die Afrikaner se Goue Kalf</em> onthul die skokkende waarheid agter een van 
              Suid-Afrika se mees geliefde nasionale monumente. Deur noukeurige navorsing en 
              Bybelse analise, ontbloot hierdie boek die Egiptiese, Babiloniese, en Vrymesselary 
              simboliek wat in die Voortrekker Monument ingebou is.
            </p>
            <p>
              Van die bul-god Apis tot die alsiende oog van Horus, van die Shiva Lingam tot 
              die ster van Ishtar — hierdie boek dokumenteer hoe heidense simbole en afgodediens 
              verweef is in die hart van Afrikaner-identiteit.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              Die Stem van Suid-Afrika: 'n Ode aan 'n Afgod?
            </h2>
            <p className="mb-4">
              Een van die boek se mees uitdagende hoofstukke ondersoek Die Stem van Suid-Afrika 
              as 'n godsdienstige lied — 'n gesang aan 'n valse god. Deur taalkundige en teologiese 
              analise, word gewys hoe die lied nie aan die Lewende God (YHWH) gerig is nie, 
              maar aan 'n abstrakte "vaderlandsgod."
            </p>
            <p>
              Die boek vra die ongemaklike vraag: Het ons as volk, sonder om dit te besef, 
              ons stemme verhef in aanbidding van 'n afgod?
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              Vrymesselary en Verborge Invloed
            </h2>
            <p className="mb-4">
              Die boek dokumenteer die rol van Vrymesselary in Suid-Afrikaanse geskiedenis, 
              van Piet Retief se lidmaatskap daarvan tot die simboliek in die FAK Volksangbundel. 
              Met bewyse uit historiese dokumente en simboliese analise, word die verborge 
              netwerke van invloed blootgelê.
            </p>
            <p>
              Hierdie is geen samesweringsteorie nie, maar 'n gedokumenteerde ondersoek gebaseer 
              op historiese feite en Bybelse waarheid.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              'n Oproep tot Bekering
            </h2>
            <p className="mb-4">
              Uiteindelik is hierdie boek nie 'n akademiese studie alleen nie, maar 'n 
              geestelike oproep. Dit is 'n uitnodiging tot die Afrikaner volk om hulle afgode 
              te vernietig, te berou oor hulle afdwaling, en terug te keer na die ware God.
            </p>
            <p>
              Die boek eindig met 'n gebed vir vergifnis en vryheid — 'n gebed dat ons as 
              volk losgemaak sal word van die bande van afgodediens en herstel sal word in 
              ons verhouding met die Lewende God.
            </p>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              Hoofstuk Oorsig
            </h2>
            <p className="mb-4">Die boek is verdeel in 37 hoofstukke wat die volgende onderwerpe dek:</p>
            <ul className="list-none space-y-2 ml-6">
              <li className="border-l-2 border-gold pl-4">Die Gelofte en Geloftedag</li>
              <li className="border-l-2 border-gold pl-4">Gerhard Moerdijk en die Duitse Völkerschlachtdenkmal</li>
              <li className="border-l-2 border-gold pl-4">Egiptiese simbole: Hathor, Apis, Mehet-Weret</li>
              <li className="border-l-2 border-gold pl-4">Bul-aanbidding: Molog, Nandi, en die Goue Kalf</li>
              <li className="border-l-2 border-gold pl-4">Babiloniese invloede en die Ster van Ishtar</li>
              <li className="border-l-2 border-gold pl-4">Shiva Lingam en die 16 Desember sonstraal</li>
              <li className="border-l-2 border-gold pl-4">Son-aanbidding en Vrymesselary simboliek</li>
              <li className="border-l-2 border-gold pl-4">Piet Retief se Vrymesselaar-verbande</li>
              <li className="border-l-2 border-gold pl-4">Die Stem van Suid-Afrika as afgodslied</li>
              <li className="border-l-2 border-gold pl-4">C.J. Langenhoven se Vrymesselaar-lidmaatskap</li>
              <li className="border-l-2 border-gold pl-4">Vloeke en die gevolge van afgodediens</li>
            </ul>
          </section>

          <section>
            <h2 className="font-heading text-2xl md:text-3xl font-medium italic mb-6 text-charcoal">
              Vir Wie is Hierdie Boek?
            </h2>
            <p>
              Hierdie werk is bedoel vir elke gelowige Afrikaner wat die waarheid soek, 
              ongeag hoe ongemaklik dit mag wees. Dit is vir elkeen wat bereid is om hulle 
              nasionale ikone deur die lens van God se Woord te ondersoek, en wat die moed 
              het om te buig voor die waarheid eerder as voor tradisie.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default About;
